import React from 'react';
import { CheckCircle, XCircle, X } from 'phosphor-react';
import './SToast.css';

export type ToastVariant = 'error' | 'success';

export interface SToastProps {
  variant: ToastVariant;
  title: string;
  message: string;
  onDismiss?: () => void;
  // kept for interface compatibility — no longer rendered
  ctaText?: string;
  onCtaClick?: () => void;
}

const SToast: React.FC<SToastProps> = ({ variant, title, message, onDismiss }) => {
  const Icon = variant === 'success' ? CheckCircle : XCircle;

  return (
    <div className={`s-toast s-toast--${variant}`}>
      <div className="s-toast-icon-wrap">
        <Icon size={22} weight="fill" className="s-toast-icon" />
      </div>

      <div className="s-toast-body">
        <p className="s-toast-title">{title}</p>
        {message && <p className="s-toast-message">{message}</p>}
      </div>

      {onDismiss && (
        <button className="s-toast-close" onClick={onDismiss} aria-label="Dismiss">
          <X size={14} weight="bold" />
        </button>
      )}
    </div>
  );
};

export default SToast;
